import axios from '../axios'
import { checkResponse, getProjectId } from '../utils'

/**
 * @function getSameCasePoints
 * @desc 获取相似案件地图点位信息
 * @returns {Object}
 */
const getSameCasePoints = (query) => {
  return axios
    .get(`/api/v1/projects/${getProjectId()}/similarity/similarityMap?${query}`)
    .then(checkResponse)
}

/**
 * @function getRePoints
 * @desc 获取复发点位数据
 * @returns {Object}
 */
const getRePoints = (query) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/similarity/recur/list?${query || ''}`
    )
    .then(checkResponse)
}

/**
 * @function getGeo
 * @desc 100年数据地块
 * @returns {Object}
 */
const getGeo = (query) => {
  return axios
    .get(
      `/api/v1/projects/${getProjectId()}/cases_scoring/geo_json?${query}`
    )
    .then(checkResponse)
}
export{
  getSameCasePoints,
  getRePoints,
  getGeo
}
